import Vue from 'vue';
import VueRouter from 'vue-router';
import Signup from '@/views/Signup.vue';
import SignupVerify from '@/views/SignupVerify.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: `/signup`,
    name: `signup`,
    component: Signup,
  },
  {
    path: `/signup/:token`,
    name: `signupSpace`,
    component: Signup,
  },
  {
    path: `/signup/:token/check-email`,
    name: `signupCheckEmail`,
    component: Signup,
  },
  {
    path: `/signup/:token/verify/:verifyToken`,
    name: `signupVerify`,
    component: SignupVerify,
  },
  {
    path: `*`,
    redirect: { name: `signup` },
  },
];

const router = new VueRouter({
  mode: `history`,
  base: process.env.BASE_URL,
  routes,
});

export default router;
